import React, { useState } from "react";

type PrimaryButtonProps = {
  id?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  startIcon?: React.ReactNode;
  mobile?: boolean;
  confetti?: boolean;
  shimmer?: boolean;
};

function PrimaryButton({
  id,
  type,
  disabled,
  children,
  onClick = () => {},
  className,
  startIcon,
  mobile = false,
  confetti = false,
  shimmer = false, // New shimmer parameter
}: PrimaryButtonProps) {
  const [confettiState, setConfettiState] = useState(false);

  const baseClasses =
    "flex items-center shadow-md text-white text-h2 min-w-fit  w-fit font-medium border-0 transition-all duration-200 ease-in-out flex flex-row gap-2 items-center";
  const mobileClasses = mobile
    ? "px-4 py-1 rounded-full bg-primary  hover:bg-primary_l"
    : "px-4 py-2 rounded-lg    bg-primary hover:bg-primary_l";

  const shadowClasses =
    "shadow-[0px_1px_5px_rgba(0,0,0,0.2)] hover:shadow-[0_0_0_0.2rem_rgba(0,0,0,0.2)]";
  const disabledClasses = disabled
    ? "opacity-50 cursor-not-allowed"
    : "cursor-pointer";
  const shimmerClasses = shimmer
    ? "relative overflow-hidden animate-pulse min-w-fit"
    : "";

  const buttonClasses = `${baseClasses} ${mobileClasses} ${shadowClasses} ${disabledClasses} ${shimmerClasses} ${
    className || ""
  }`;

  return (
    <button
      id={id}
      type={type}
      disabled={disabled}
      className={buttonClasses}
      onClick={(e) => {
        onClick(e);
        confetti && setConfettiState(true);
      }}
    >
      {confettiState && <></>}
      {startIcon}
      {children}
    </button>
  );
}

export default PrimaryButton;
